import { action, observable } from 'mobx';

class TranslationStore {

    // PROPERTIES

    @observable CurrentLanguage = undefined;
    @observable currentLanguageShort = undefined;
    @observable currentLanguageFull = undefined;

    @action getLanguage() {
        const selectedLang = window.localStorage.getItem('lang');
        this.CurrentLanguage = selectedLang;
        return selectedLang;
    }

    // SET PROPERTIES

    @action setLanguage(selectedLanguage) {
        window.localStorage.setItem('lang', selectedLanguage);
    }

    @action setCurrentLanguageShort(selectedLanguage) {
        if (selectedLanguage === 'en') {
            this.currentLanguageShort = 'EN';
        } else if (selectedLanguage === 'zh') {
            this.currentLanguageShort = 'CN';
        } else if (selectedLanguage === 'zh-Hant') {
            this.currentLanguageShort = 'CNH';
        } else if (selectedLanguage === 'th') {
            this.currentLanguageShort = 'TH';
        } else if (selectedLanguage === 'ja') {
            this.currentLanguageShort = 'JA';
        } else if (selectedLanguage === 'fr') {
            this.currentLanguageShort = 'FR';
        } else if (selectedLanguage === 'es') {
            this.currentLanguageShort = 'ES';
        }
    }

    @action setCurrentLanguageFull(selectedLanguage) {
        if (selectedLanguage === 'en') {
            this.currentLanguageFull = 'English';
        } else if (selectedLanguage === 'zh') {
            this.currentLanguageFull = '简体中文';
        } else if (selectedLanguage === 'zh-Hant') {
            this.currentLanguageFull = '繁體中文';
        } else if (selectedLanguage === 'th') {
            this.currentLanguageFull = 'ไทย';
        } else if (selectedLanguage === 'ja') {
            this.currentLanguageFull = '日本語';
        } else if (selectedLanguage === 'fr') {
            this.currentLanguageFull = 'français';
        }else if (selectedLanguage === 'es') {
            this.currentLanguageFull = 'español';
        }
    }
}

export default new TranslationStore();